import { useTranslation } from 'react-i18next'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { KibSpinner } from '@chewy/kib-interstitials-react'

import { ContextualBackButton } from '~/components/common/buttons/ContextualBackButton'
import { RightRailOverlayProvider } from '~/components/dashboard/soapV2/context/RightRailOverlayContext'
import { PatientMedicalSummaryRail } from '~/components/dashboard/soapV2/summary/PatientMedicalSummaryRail'

import ClientAndPatientSection from './details/new-client-and-patient/ClientAndPatientSection'
import { RxCardDetails } from './timeline/prescriptions/rxTracker/RxCardDetails'
import RxCardHeader from './timeline/RxCardHeader'
import {
  isDrugSubtype,
  usePrescriptionDetailsContent,
} from './usePrescriptionDetailsContent'

import '@chewy/kib-interstitials-styles/dist/styles/kib-spinner.css'
import styles from './PrescriptionDetailsPage.module.scss'

const PrescriptionDetailsPage = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('Common')
  const { itemId } = useParams()
  const [searchParams] = useSearchParams()

  const mode = isDrugSubtype(searchParams.get('subtype'))
    ? 'orderedDrug'
    : 'prescription'

  const { item, clientId, patientId, isLoading, hasData } =
    usePrescriptionDetailsContent(itemId, mode)

  const handleBackNavigation = () => {
    if (clientId && patientId) {
      navigate(`/client/${clientId}/patient/${patientId}`)
    } else if (clientId) {
      navigate(`/client/${clientId}`)
    } else {
      navigate(-1)
    }
  }

  return (
    <div className={styles.root}>
      {clientId && (
        <div className={styles.clientSection}>
          <ClientAndPatientSection
            clientId={clientId}
            patientId={patientId ?? undefined}
          />
        </div>
      )}
      <div className={styles.mainContent}>
        <ContextualBackButton
          buttonText={t('Common:CLIENT_AND_PATIENT_DETAIL')}
          navigateBackToContext={handleBackNavigation}
        />
        <div className={styles.content}>
          <div className={styles.header}>
            {isLoading && (
              <div className={styles.loading}>
                <KibSpinner />
              </div>
            )}
            {!isLoading && hasData && item?.prescription && (
              <div className={styles.rxContainer}>
                <RxCardHeader item={item} />
                <div className={styles.rxDetailsContainer}>
                  <RxCardDetails isDetailView item={item} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {clientId && patientId && (
        <div className={styles.rightRail}>
          <RightRailOverlayProvider>
            <PatientMedicalSummaryRail
              clientId={clientId}
              patientId={patientId}
            />
          </RightRailOverlayProvider>
        </div>
      )}
    </div>
  )
}

export { PrescriptionDetailsPage }
